import type { Repayment, RepaymentGateway, RepaymentReconciliationStatus } from '@/shared/models/repaymentModel'
import { SafeMath } from './numberUtils'

export const mapRepayment = (repayment: RepaymentGateway): Repayment => {
    const totalAllocations =
        repayment.paymentReconciliations?.reduce((acc, curr) => SafeMath.add(acc, curr.allocatedAmount), 0) ?? 0

    const mapRepaymentAllocationsStatus = (): RepaymentReconciliationStatus => {
        if (totalAllocations >= repayment.amount) return 'RECONCILIATED'
        if (totalAllocations > 0 && totalAllocations < repayment.amount) return 'PARTIALLY_RECONCILIATED'

        return 'NOT_RECONCILIATED'
    }

    return {
        ...repayment,
        balance: SafeMath.subtract(repayment.amount, totalAllocations),
        allocationsStatus: mapRepaymentAllocationsStatus()
    }
}
